import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { NotFoundComponent } from "./core/components/not-found/not-found.component";
import { AuthGuardService } from "./shared/services/auth/auth-guard.service";
import { config } from "src/assets/config/config";
import { regionMatcher } from "src/assets/config/region-matcher";

 import { Country } from 'src/app/shared/country.type';

let country: Country = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
const routes: Routes = [
  { path: "404", component: NotFoundComponent },

  {
    path: "",
    redirectTo: config[country].landingPage ? `/${config[country].region}/landing-page` : (config[country].defaultRedirectOnBootstrap !== "") ? `/${config[country].region}${config[country].defaultRedirectOnBootstrap}` : `/${config[country].region}/home`,
    pathMatch: "full",
  },
  {
    path: "home",
    redirectTo: '/en-us/home',
    pathMatch: "full",
  },
  { path: ':region', redirectTo: config[country].landingPage ? `:region/landing-page` : (config[country].defaultRedirectOnBootstrap !== "") ? `/${config[country].region}${config[country].defaultRedirectOnBootstrap}`  : `:region/home`, pathMatch: 'full' },
  {
    matcher: regionMatcher,
    children: [
      {
        path: "landing-page",
        loadChildren: () =>
          import("./shared/shared.module").then((mod) => mod.SharedModule)

      },
      {
        path: "home",
        loadChildren: () => {
          switch (config[country].region) {
            case "en-us":
              return import("./module/us/us.module").then(
                (mod) => mod.USModule
              );
              case "en-uk":
              return import("./module/uk/uk.module").then(
                (mod) => mod.UKModule
              );
            default:
              return import("./shared/shared.module").then(
                (mod) => mod.SharedModule
              );
          }
        },
        canActivate: [AuthGuardService],
      },
      {
        path: "private",
        loadChildren: () => {
          switch (config[country].region) {
            case "sv-se":
              return import("./module/sweden/sweden.module").then((mod) => mod.SwedenModule); // Load sweden specific module
            case "no-no":
              return import("./module/norway/norway.module").then((mod) => mod.NorwayModule); // Load norway specific module
              case "de-de":
                return import("./module/germany/germany.module").then((mod) => mod.GermanyModule); // Load norway specific module
              case "fi-fi":
                return import("./module/finland/finland.module").then((mod) => mod.FinlandModule); // Load finland specific module
                case "da-dk":
                  return import("./module/denmark/denmark.module").then((mod) => mod.DenmarkModule); // Load finland specific module
              default:
              return import("./module/sweden/sweden.module").then((mod) => mod.SwedenModule);
          }
        }
      },
      {
        path: "non-customer",
        loadChildren: () => {
          switch (config[country].region) {
            case "no-no":
              return import("./module/norway/components/home-no/home-no.module").then((mod) => mod.HomeNoModule); // Load norway specific module
              case "fi-fi":
                return import("./module/finland/components/home-fi/home-fi.module").then((mod) => mod.HomeFiModule); // Load norway specific module
                case "da-dk":
                  return import("./module/denmark/components/home-dk/home-dk.module").then((mod) => mod.HomeDkModule); // Load finland specific module
                default:
              return import("./module/norway/components/home-no/home-no.module").then((mod) => mod.HomeNoModule);
          }
        }
      },
      {
        path: "business",
        loadChildren: () => {
          switch (config[country].region) {
            case "sv-se":
              return import("./module/sweden/components/home-se/home-se.module").then((mod) => mod.HomeSeModule); // Load sweden specific module
            default:
              return import("./module/sweden/components/home-se/home-se.module").then((mod) => mod.HomeSeModule);
          }
        }

      },
      {
        path: "search",
        loadChildren: () =>
          import("./feature/search/search.module").then((mod) => mod.SearchModule),
          canActivate: [AuthGuardService]
      },
      {
        path: "product",
        loadChildren: () =>
          import("./feature/product/product.module").then((mod) => mod.ProductModule)
        // canActivate: [AuthGuardService]
      },
    ],

  },
  { path: "**", redirectTo: "/404", pathMatch: "full" }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }